import React, { useEffect, useRef, useState } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const TestimonialsSection = () => {
  const sectionRef = useRef(null);
  const orbitRef = useRef(null);
  const [activeTestimonial, setActiveTestimonial] = useState(0);

  const testimonials = [
    {
      id: 1,
      text: "From start to finish, the communication was seamless and the design blew us away. They really know how to bring a brand to life!",
      author: "James R.",
      position: "Startup Founder",
      rating: 5,
      image: '/images/testi1.jpg'
    },
    {
      id: 2,
      text: "Outstanding service and attention to detail. The team delivered beyond our expectations and the results speak for themselves.",
      author: "Sarah M.",
      position: "Marketing Director",
      rating: 5,
      image: '/images/testi2.jpg'
    },
    {
      id: 3,
      text: "Professional, creative, and incredibly responsive. Working with this team was an absolute pleasure from day one.",
      author: "Michael K.",
      position: "CEO",
      rating: 5,
      image: '/images/testi3.jpg'
    },
    {
      id: 4,
      text: "They transformed our vision into reality with precision and creativity. Highly recommend for any digitizing needs!",
      author: "Emily P.",
      position: "Creative Lead",
      rating: 5,
      image: '/images/testi4.jpg'
    },
    {
      id: 5,
      text: "Fast turnaround, exceptional quality, and great communication throughout. Will definitely work with them again!",
      author: "David L.",
      position: "Product Manager",
      rating: 5,
      image: '/images/testi5.jpg'
    },
    {
      id: 6,
      text: "The level of expertise and professionalism exceeded all expectations. Our project turned out perfectly!",
      author: "Lisa W.",
      position: "Brand Strategist",
      rating: 5,
      image: '/images/testi6.jpg'
    },
    {
      id: 7,
      text: "Incredible attention to detail and a genuine passion for quality work. They went above and beyond!",
      author: "Robert H.",
      position: "Business Owner",
      rating: 5,
      image: '/images/testi7.jpg'
    },
    {
      id: 8,
      text: "Creative solutions, timely delivery, and outstanding results. Couldn't ask for a better partner!",
      author: "Amanda T.",
      position: "Design Director",
      rating: 5,
      image: '/images/testi8.jpg'
    },
    {
      id: 9,
      text: "Professional service with a personal touch. They made the entire process smooth and enjoyable.",
      author: "Chris B.",
      position: "Operations Manager",
      rating: 5,
      image: '/images/testi9.jpg'
    },
    {
      id: 10,
      text: "Top-notch quality and exceptional customer service. They delivered exactly what we needed and more!",
      author: "Jennifer S.",
      position: "Marketing Specialist",
      rating: 5,
      image: '/images/testi1.jpg'
    }
  ];

  const allAvatars = [
    ...testimonials,
    ...testimonials.slice(0, 18),
  ];

  useEffect(() => {
    const section = sectionRef.current;
    const orbit = orbitRef.current;

    // FIX: Use gsap.set() directly instead of gsap.to() inside onUpdate.
    // gsap.to() inside onUpdate spawns a NEW tween every single scroll tick,
    // flooding the tween engine and causing scroll jank.
    ScrollTrigger.create({
      trigger: section,
      start: 'top bottom',
      end: 'bottom top',
      scrub: 2,
      onUpdate: (self) => {
        const rotationValue = self.progress * 720;
        gsap.set(orbit, { rotation: rotationValue });
      }
    });

    return () => {
      ScrollTrigger.getAll().forEach(trigger => trigger.kill());
    };
  }, []);

  const handleAvatarClick = (index) => {
    const testimonialIndex = index % testimonials.length;
    setActiveTestimonial(testimonialIndex);
  };

  return (
    <section className="testiminals-textsec" ref={sectionRef}>
      <div className="container">
        <div className="testiminals-textsec-content">
          <div className="testiminals-textsec-orbit" ref={orbitRef}>
            {allAvatars.map((avatar, index) => {
              const angle = (360 / allAvatars.length) * index;
              const radius = 550;
              const x = Math.cos((angle - 90) * Math.PI / 180) * radius;
              const y = Math.sin((angle - 90) * Math.PI / 180) * radius;

              const testimonialIndex = index % testimonials.length;
              const isActive = activeTestimonial === testimonialIndex;

              return (
                <div
                  key={`avatar-${index}`}
                  className={`testimonial-avatar ${isActive ? 'active' : ''}`}
                  style={{
                    transform: `translate(${x}px, ${y}px)`
                  }}
                  onClick={() => handleAvatarClick(index)}
                >
                  <div className="testimonial-avatar-inner">
                    <img src={avatar.image} alt={avatar.author} />
                    <div className="testimonial-avatar-ring"></div>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="testiminals-textsec-card">
            <div className="testiminals-textsec-quote-icon">
              <svg width="60" height="60" viewBox="0 0 24 24" fill="currentColor">
                <path d="M6 17h3l2-4V7H5v6h3zm8 0h3l2-4V7h-6v6h3z"/>
              </svg>
            </div>

            <p className="testiminals-textsec-text">
              "{testimonials[activeTestimonial].text}"
            </p>

            <div className="testiminals-textsec-rating">
              {[...Array(testimonials[activeTestimonial].rating)].map((_, i) => (
                <svg key={i} width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                </svg>
              ))}
            </div>

            <div className="testiminals-textsec-author">
              <p className="testiminals-textsec-author-name">— {testimonials[activeTestimonial].author}</p>
              <p className="testiminals-textsec-author-position">{testimonials[activeTestimonial].position}</p>
            </div>
          </div>
        </div>

        <div className="testiminals-textsec-bottom-fade"></div>
      </div>
    </section>
  );
};

export default TestimonialsSection;